import moment from "moment";
import "moment/locale/es";
import { cuentaMask, dineroDisabledMask } from '../Components/Items';
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reporteInsumosMasCompradosPdf = (values) => {
    const empresa = values.empresa || {};
    const logoBiwo = values.logoBiwo || {};
    let filtrados = [];

    if (values.proveedores !== 0 && values.proveedores && values.proveedores.length > 0) {
        let textoFiltrado = '';
        values.proveedores.forEach((p) => { textoFiltrado += `${p.nombre || p.razonSocial} - ${p.rfc}\n`; });
        filtrados.push([{ text: 'Proveedores:', style: 'subheader' }, { text: textoFiltrado, style: 'textoChico' }]);
    }

    if (values.filtrarProyecto === 1) {
        let textoFiltrado = '';
        values.proyectos.forEach((p) => { textoFiltrado += `${p.nombre}\n`; });
        filtrados.push([{ text: 'Proyectos:', style: 'subheader' }, { text: textoFiltrado, style: 'textoChico' }]);
    }

    if (values.filtrarProyecto === 2) {
        filtrados.push([{ text: 'Unidad de Negocio:', style: 'subheader' }, { text: `${cuentaMask(values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 + values.unidadDeNegocio.nivel5)} - ${values.unidadDeNegocio.nombre}`, style: 'textoChico' }]);
    }

    if (filtrados.length === 0) filtrados.push([{ text: 'No tiene filtrados adicionales', style: 'subheader' }, { text: '', style: 'textoChico' }]);

    const headerTabla = [
        { text: 'Clave', style: 'tituloTabla' },
        { text: 'Cód. Barras', style: 'tituloTabla' },
        { text: 'Descripción', style: 'tituloTabla' },
        { text: 'Familia', style: 'tituloTabla' },
        { text: 'Marca', style: 'tituloTabla' },
        { text: 'Tipo', style: 'tituloTabla' },
        { text: 'Cant.', style: 'tituloTabla' },
        { text: 'Costo Unit.', style: 'tituloTabla' },
        { text: 'Costo Total', style: 'tituloTabla' },
        { text: 'Costo Total (MXN)', style: 'tituloTabla' }
    ];

    const anchosTabla = ['7%', '9%', '21%', '9%', '9%', '9%', '7%', '9%', '10%', '10%'];

    const tablasDinamicas = [];
    const porMoneda = {};

    (values.insumos || []).forEach((insumo) => {
        const monedaKey = insumo.moneda || "MXN";
        if (!porMoneda[monedaKey]) porMoneda[monedaKey] = [];
        porMoneda[monedaKey].push(insumo);
    });

    let granTotalCantidad = 0;
    let granTotalCostoMxn = 0;

    Object.keys(porMoneda).forEach((moneda) => {
        const insumosMoneda = porMoneda[moneda];

        let totalCantidad = 0;
        let totalCosto = 0;
        let totalCostoMxn = 0;

        const filasInsumos = insumosMoneda.map((item) => {
            totalCantidad += parseFloat(item.cantidad || 0);
            totalCosto += parseFloat(item.costoTotal || 0);
            totalCostoMxn += parseFloat(item.costoTotalMxn || 0);

            return [
                { text: item.clave || 'N/A', style: 'textoTabla', alignment: 'left' },
                { text: item.codigoBarras || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.descripcion || '', style: 'textoTabla', alignment: 'left' },
                { text: item.familia || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.marca || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.tipoInsumo || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.cantidad || 0, style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(item.precioUnitario), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(item.costoTotal), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(item.costoTotalMxn), style: 'textoTabla', alignment: 'right' }
            ];
        });

        granTotalCantidad += totalCantidad;
        granTotalCostoMxn += totalCostoMxn;

        let filaTotales = [
            { text: `TOTALES (${moneda}):`, style: 'totalChico', alignment: 'left', colSpan: 6, border: [true, true, true, true], fillColor: '#cccccc' },
            {}, {}, {}, {}, {},
            { text: totalCantidad, style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: '', style: 'totalChico', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: dineroDisabledMask(totalCosto), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: dineroDisabledMask(totalCostoMxn), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' }
        ];

        tablasDinamicas.push(
            { text: `Moneda: ${moneda}`, style: "subheader", margin: [0, 5, 0, 2] },
            {
                style: 'tableExample',
                table: { 
                    widths: anchosTabla, 
                    headerRows: 1, 
                    body: [headerTabla, ...filasInsumos, filaTotales] 
                },
                layout: { 
                    fillColor: (rowIndex) => rowIndex % 2 === 0 && rowIndex !== 0 ? "#e8e8e8" : "#ffffff", 
                    hLineWidth: () => 1, 
                    vLineWidth: () => 1, 
                    hLineColor: () => '#adaaaa', 
                    vLineColor: () => '#adaaaa' 
                }
            },
            { text: "", margin: [0, 0, 0, 10] } 
        );
    });


    tablasDinamicas.push({
        style: 'tableExample',
        table: {
            widths: anchosTabla,
            body: [[
                { text: 'GRAN TOTAL:', style: 'totalChico', alignment: 'left', colSpan: 6, border: [true, true, true, true], fillColor: '#aaaaaa' },
                {}, {}, {}, {}, {},
                { text: granTotalCantidad, style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#aaaaaa' },
                { text: '', style: 'totalChico', border: [true, true, true, true], fillColor: '#aaaaaa' },
                { text: '', style: 'totalChico', border: [true, true, true, true], fillColor: '#aaaaaa' },
                { text: dineroDisabledMask(granTotalCostoMxn), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#aaaaaa' },
            ]]
        },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#aaaaaa', vLineColor: () => '#aaaaaa' }
    });

    return {
        pageOrientation: 'landscape',
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
        footer: { image: 'logoBiwo', alignment: 'center', width: 80 },
        images: { logo: empresa?.logo?.base64Completa , logoBiwo: logoBiwo?.base64Completa},
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['15%', '55%', '30%'],
                    layout: 'noBorders',
                    body: [
                        [
                            ...HeaderEmpresaCard(empresa, !empresa?.deshabilitarRegimenFiscal, false, {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1, widths: ['100%'],
                                    body: [
                                        [{ text: 'Fecha Inicial:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        [{ text: 'Fecha Final:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                    ]
                                }, layout: 'noBorders'
                            })
                        ]
                    ]
                }
            },
            { text: 'REPORTE DE INSUMOS MÁS COMPRADOS', style: 'tableHeaderIzquierda', margin: [0, 5, 0, 10] },
            { text: 'Datos de filtrado:' },
            {
                style: 'tableExample',
                table: { widths: ['15%', '85%'], layout: { defaultBorder: false }, body: filtrados },
                layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#adaaaa', vLineColor: () => '#adaaaa', hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } }, vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } } }
            },
            { text: "", margin: [0, 0, 0, 5] },
            ...tablasDinamicas
        ],
        styles: { header: { fontSize: 9, bold: true }, subheader: { fontSize: 8, bold: true }, tableExample: { margin: [0, 5, 0, 5] }, tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' }, tableHeaderIzquierda: { bold: true, fontSize: 14, color: 'black', alignment: 'center' }, textoChico: { fontSize: 8 }, tituloTabla: { fontSize: 7, bold: true, fillColor: '#cccccc', style: 'subheader', alignment: 'center', border: true }, textoTabla: { fontSize: 7, italics: false }, totalChico: { fontSize: 7, bold: true, fillColor: '#cccccc', alignment: 'right', border: true } }
    };
};

export default reporteInsumosMasCompradosPdf;